import TitleCell from './TitleCell';
import TrafficValueCell from './TrafficValueCell';
import { getRegionalInfo, regionalTrafficValAvg } from './utils';
import { ContentValueStoryLevelStats, ContentValueTrafficValue } from 'types';
import { Cell } from './types';
import { removeCentsAddCommas } from '../value/utilities';
import { P, DataTable } from 'toolkit/components';

interface TableWrapperProps {
  region: string;
  tableInfo: ContentValueStoryLevelStats[];
  trafficValAvg: ContentValueTrafficValue;
}

function TableWrapper({ region, tableInfo, trafficValAvg }: TableWrapperProps) {
  const contentSpend = (cell: number) => `${removeCentsAddCommas(cell)}`;
  const pillar = (pillarName: string) => pillarName || 'No Pillar';

  const defaultColumns = [
    {
      Header: 'Title',
      accessor: 'title',
      minWidth: 350,
      Cell: TitleCell,
    },
    {
      Header: 'Pillar',
      accessor: 'contentPillar',
      Cell: (props: Cell) => <P>{pillar(props.cell.value as string)}</P>,
    },
    {
      Header: 'Spend',
      accessor: 'contentSpend',
      Cell: (props: Cell) => <P>{contentSpend(Number(props.cell.value))}</P>,
    },
    {
      Header: 'SEO Traffic',
      accessor: `${getRegionalInfo(region)}Traffic`,
      Cell: (props: Cell) => <P>{props.cell.value}</P>,
    },
    {
      Header: 'SEO Traffic Value',
      accessor: `${getRegionalInfo(region)}TrafficValue`,
      Cell: (props: Cell) => (
        <TrafficValueCell
          data={props}
          trafficValAvg={regionalTrafficValAvg(region, trafficValAvg)}
        />
      ),
    },
  ];
  const pageSize = 10;
  return (
    <DataTable.Table
      data={tableInfo}
      columns={defaultColumns}
      pageSize={pageSize}
      pageCount={Math.ceil(tableInfo.length / pageSize)}
      showTotal={false}
      defaultSortBy={[{ id: `${getRegionalInfo(region)}TrafficValue`, desc: true }]}
      errorMessage="No data is available yet - please add published URLs in order to see the content value of your stories next month."
    />
  );
}

export default TableWrapper;
